export default "__VITE_ASSET__CxIIL30I__"